import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Utility } from '../../core/utils/utility';
import { SignalrService } from '../../panel/_services/signalr.service';
import { Subject, tap } from 'rxjs';
import { AuthService } from '../../auth/_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {


  pendingCount = 0;
  pendingCount$: Subject<number> = new Subject<number>();

  constructor(
    private http: HttpClient,
    private signalr: SignalrService,
    private authService: AuthService
  ) {
    signalr.homeWorkSubmitted.subscribe(x => {
      this.pendingCount++;
      this.pendingCount$.next(this.pendingCount);
    })

    signalr.homeWorkEvaluated.subscribe(x => {
      this.pendingCount--;
      this.pendingCount$.next(this.pendingCount);
    })

    if (authService.isTenantAdminOrOperator && !authService.isAdmin) {
      this.getAllHomeworks({ filter: { tenantId: localStorage.getItem('tenantId') } }).subscribe();
    }
  }

  get(filter: any | null = null) {
    let params = new HttpParams();
    for (const key in filter) {
      if (filter[key])
        params = params.append(key, filter[key])
    }

    return this.http.get(`${environment.apiUrl}/InnovationAssignment`, { params: params })
  }

  getForStudent(filter: any | null = null) {
    let params = new HttpParams();
    for (const key in filter) {
      if (filter[key])
        params = params.append(key, filter[key])
    }

    return this.http.get(`${environment.apiUrl}/InnovationAssignment/student`, { params: params })
  }

  getStudentAssignments(courseId: number, assignmentForUserIds: any = [], scopeId: string | null) {
    let params = new HttpParams();
    if (assignmentForUserIds?.length) {
      assignmentForUserIds.forEach((item: any) => {
        params = params.append('assignmentForUserIds', item);
      });
    }

    if (scopeId) {
      params = params.append('scopeId', scopeId);
    }

    params = params.append('courseId', courseId);

    return this.http.get(`${environment.apiUrl}/Assignment/student`, { params: params })
  }

  getById(id: number) {
    return this.http.get(`${environment.apiUrl}/Assignment/${id}`)
  }

  getByIdForStudent(id: number) {
    return this.http.get(`${environment.apiUrl}/Assignment/student/${id}`)
  }

  getHomeworks(assignmentIds: any, assignmentForUserIds: any = [], scopeId: string | null) {
    let params = new HttpParams();
    if (assignmentForUserIds?.length) {
      assignmentForUserIds.forEach((item: any) => {
        params = params.append('assignmentForUserIds', item);
      });
    }
    if (scopeId) {
      params = params.append('scopeId', scopeId);
    }
     assignmentIds.forEach((item: any) => {
        params = params.append('assignmentIds', item);
      });
    return this.http.get(`${environment.apiUrl}/Assignment/homework`, { params: params })
  }

  getAllHomeworks(filter: any) {
    let params = Utility.tableStateToHttpParams(filter);

    return this.http.get(`${environment.apiUrl}/InnovationAssignment/homework/list`, { params: params }).pipe(
      tap((res: any) => {
        this.pendingCount = res.result.filter((x: any) => x.status == 0)?.length;
        this.pendingCount$.next(this.pendingCount);
      })
    )
  }

  getHomeworkById(id: any) {
    return this.http.get(`${environment.apiUrl}/Assignment/homework/${id}`);
  }

  getHomeworkByAssignmentId(id: string, scopeId: string | null) {
    return this.http.get(`${environment.apiUrl}/Assignment/homework/getByAssignmentId/${id}`, { params: { id, scopeId: scopeId || '' } });
  }

  deleteHomework(id: number) {
    return this.http.delete(`${environment.apiUrl}/InnovationAssignment/homework/${id}`)
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/InnovationAssignment/${id}`)
  }


  add(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.post(`${environment.apiUrl}/InnovationAssignment`, formData, options)
  }

  update(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.put(`${environment.apiUrl}/InnovationAssignment`, formData, options)
  }

  deleteAttachment(id: any) {
    return this.http.delete(`${environment.apiUrl}/InnovationAssignment/attachment`, { params: { id } });
  }


  deleteHomeWorkAttachment(id: any) {
    return this.http.delete(`${environment.apiUrl}/Assignment/homework/attachment`, { params: { id } });
  }

  downloadAssignment(id: number) {
    return this.http.get(`${environment.apiUrl}/Assignment/attachments/${id}`, { responseType: 'blob' });
  }

  submitHomework(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };
    return this.http.post(`${environment.apiUrl}/InnovationAssignment/homework`, formData, options)
  }

  evaluate(value: any) {
    return this.http.post(`${environment.apiUrl}/InnovationAssignment/homework/evaluate`, value)
  }

  getHomeworkAttachment(id: any) {
    return this.http.get(`${environment.apiUrl}/InnovationAssignment/homework/attachment/${id}`, { responseType: 'blob' });
  }
}
